module.exports = __webpack_public_path__ + "img/ring_g_i_1_null.6162abe2.png";